import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface PermissionDTO {
  value: string;
  description: string;
  global: boolean;
}

export interface RoleDTO {
  value: string;
  description: string;
  system: boolean;
  global: boolean;
  permissions: PermissionDTO[];
}

export interface WrapperResponseListRoleDTO {
  ok: boolean;
  code: number;
  message: string;
  metadata?: unknown;
  body: RoleDTO[];
}

/** Mapeo de value del API al nombre del enum que espera el PUT de usuarios */
const ROLE_VALUE_TO_ENUM_NAME: Record<string, string> = {
  defaults: 'DEFAULT_USER_PERMISSIONS',
  sales: 'SALES',
  billing: 'BILLING',
  company_admin: 'COMPANY_ADMIN',
  admin: 'ADMIN'
};

@Injectable({
  providedIn: 'root'
})
export class RoleService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl;

  getRoles(): Observable<WrapperResponseListRoleDTO> {
    return this.http.get<WrapperResponseListRoleDTO>(`${this.apiUrl}/roles`);
  }

  getUserRoles(userId: number): Observable<WrapperResponseListRoleDTO> {
    return this.http.get<WrapperResponseListRoleDTO>(`${this.apiUrl}/users/${userId}/roles`);
  }

  /** Convierte el value del rol (ej. "admin") al nombre enum para el body del PUT (ej. "ADMIN") */
  roleValueToEnumName(value: string): string {
    return ROLE_VALUE_TO_ENUM_NAME[value] ?? value.replace(/[^a-zA-Z0-9_]/g, '_').toUpperCase();
  }
}
